

import React, { Suspense, lazy} from 'react';
import {Routes, Route, Navigate } from 'react-router-dom';

 import SidebarNavbar from './components/Navbar/SideNavbar';

 import { PreventLoginAccessRoute, ProtectedRoute } from './App';
 
// Lazy loading pages and components
import Home from './pages/Website/Home';
const TrendingProducts = lazy(() => import('./pages/Website/TrendingProducts'));
const Login = lazy(() => import('./pages/Website/Login'));
const Signup = lazy(() => import('./pages/Website/Signup'));
const Faq = lazy(() => import('./pages/Website/Faq'));
const Search = lazy(() => import('./pages/Website/Search'));
const ProductPage = lazy(() => import('./pages/Website/ProductPage'));
const PrivacyPolicy = lazy(() => import('./pages/Website/PrivacyPolicy'));
const Terms = lazy(() => import('./pages/Website/Terms'));
const ShippingPolicy = lazy(() => import('./pages/Website/ShippingPolicy'));
const RefundPolicy = lazy(() => import('./pages/Website/RefundPolicy'));
const Categories = lazy(() => import('./pages/Website/Categories'));
const Subscriptions = lazy(() => import('./pages/Website/Subscriptions'));
const SubscriptionSummary = lazy(() => import('./pages/Website/SubscriptionSummary'));
const Vouchers = lazy(() => import('./pages/Website/Vouchers'));
const PurchaseVoucher = lazy(() => import('./pages/Website/PurchaseVoucher'));
const OrderSummary = lazy(() => import('./pages/Website/OrderSummary'));
const Loading = lazy(() => import('./pages/Website/Loading'));
const VerifySuccessModal = lazy(() => import('./components/Modal/VerifySuccessModal'));
const ResetPasswordModal = lazy(() => import('./components/Modal/ResetPasswordModal'));
const CartOffCanvas = lazy(() => import('./pages/Website/Cart'));
const ProfileWishlist = lazy(() => import('./pages/Profile/ProfileWishlist'));
const PersonalData = lazy(() => import('./pages/Profile/PersonalData'));
const NewPassword = lazy(() => import('./pages/Profile/NewPassword'));
const ForgotPassword = lazy(() => import('./pages/Website/ForgotPassword'));
const OrderConfirmation = lazy(() => import('./pages/Profile/OrderConfirmation'));
const OrderDetails = lazy(() => import('./pages/Profile/OrderDetails'));
const Orders = lazy(() => import('./pages/Profile/Orders'));
const OrderModification = lazy(() => import('./pages/Profile/OrderModification'));
const UserSubscriptions = lazy(() => import('./pages/Profile/UserSubscriptions'));
const CancelSubscription = lazy(() => import('./pages/Profile/CancelSubscription'));
const Refer = lazy(() => import('./pages/Profile/Refer'));
const PartnersProgram = lazy(() => import('./pages/Website/PartnersProgram'));
const Reviews = lazy(() => import('./pages/Website/Reviews'));
const RateOrder = lazy(() => import('./pages/Profile/RateOrder'));
const ShareReview = lazy(() => import('./pages/Profile/ShareReview'));

const RoutesConfig = ({ isMobile }) => (
  <Suspense fallback={<div className='justify-content-center align-items-center text-center' style={{ padding: '100px' }}>
      <div className="spinner-border text-success" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>}>
    <Routes>
    <Route path="/" element={<Home/>} />
      <Route path="/trending-products" element={<TrendingProducts/>} />
    <Route path="/terms" element={<Terms/>} />

    <Route element={<PreventLoginAccessRoute />}>
    <Route path="/login" element={<Login/>} />
    <Route path="/signup" element={<Signup/>} />
    <Route path="/forgot-password" element={<ForgotPassword/>} />
         </Route>
 
    <Route path="/faq" element={<Faq/>} />
    <Route path="/search" element={<Search/>} />
    {isMobile && <Route path="/cart" element={<CartOffCanvas/>} />}
    {isMobile && <Route path="/dashboard" element={<SidebarNavbar/>} /> }
    <Route path="/products/:productName/:productId" element={<ProductPage />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
    <Route path="/shipping-policy" element={<ShippingPolicy/>} />
    <Route path="/refund-policy" element={<RefundPolicy/>} />     
    <Route path="/loading/:token" element={<Loading/>} />
    <Route path="/verify-email" element={<VerifySuccessModal/>} />
    <Route path="/reset-password" element={<ResetPasswordModal/>} />
    <Route path="/categories" element={<Categories/>} />
    <Route path="/category/:categoryName/:categoryId" element={<Categories/>} />
    <Route path="/foodbundles" element={<Subscriptions/>} />
    <Route path="/vouchers" element={<Vouchers/>} />
    <Route path="/virtues-partners-program" element={<PartnersProgram/>} />
    <Route path="/reviews" element={<Reviews/>} />
    

    <Route path="/order-confirmation" element={<OrderConfirmation />} />

 {/* Customers */}
    <Route element={<ProtectedRoute />}>
           <Route path="/profile/orders" element={<Orders />} />
           <Route path="/profile/refer" element={<Refer />} />
           <Route path="/profile/order-details/:orderId" element={<OrderDetails />} />
           <Route path="/profile/reviews" element={<Navigate to="/reviews" replace />} />
           <Route path="/profile/reviews/rate/:orderId" element={<RateOrder />} />
           <Route path="/sharereview" element={<ShareReview />} />
           <Route path="/profile/order-modification/:orderId" element={<OrderModification />} />
           <Route path="/vouchers/purchase/:voucherId" element={<PurchaseVoucher/>} />
           <Route path="/subscription-summary/:boxId" element={<SubscriptionSummary />} />
         
           <Route path="/profile/personal-data" element={<PersonalData />} />
           <Route path="/order-summary" element={<OrderSummary />} />
         
           <Route path="/profile/password-update" element={<NewPassword />} />
           <Route path="/profile/wishlist" element={<ProfileWishlist />} />
           <Route path="/profile/subscriptions" element={<UserSubscriptions />} />
           <Route path="/profile/subscriptions/cancel/:subscriptionId" element={<CancelSubscription />} />
         </Route>
       

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  </Suspense>
);

export default RoutesConfig;